export default function menu() {

  // Handler de scroll coalescido via requestAnimationFrame: no maximo uma
  // leitura/escrita de layout por frame, em vez de uma por evento de scroll.
  // Elemento cacheado fora do handler e listener passivo para nao bloquear o scroll.
  let headerEl = document.querySelector("#header");
  let scrollTicking = false;

  window.addEventListener(
    "scroll",
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        scrollTicking = false;
        if (!headerEl) headerEl = document.querySelector("#header");
        if (!headerEl) return;
        headerEl.classList.toggle("sticky", window.scrollY > 550);
      });
    },
    { passive: true }
  );

  const btnMobile = document.getElementById('btn-mobile');

  function toggleMenu() {
    const nav = document.getElementById('nav');
    nav.classList.toggle('active');
  }
  btnMobile.addEventListener('click', toggleMenu);

  function renderizarTipoLeilao() {
    const tipoLeilao = document.querySelector('.dropdown-menu .dropdown-content');
    const tLeilao = ['Todos os Leilões', 'TJ e Extrajudicial', 'Justiça Trabalhista', 'Encerrados'];
    if (!tipoLeilao) {
      return
    }
    const htmlTipoLeilao = tLeilao.map(tipo => {
      let params = '';
      if (tipo == 'Todos os Leilões') {
        params = ``
      }  
      else if (tipo == 'TJ e Extrajudicial') {
        params = `?tipo_leilao=JUDICIAL&tipo_leilao=EXTRAJUDICIAL&tipo_leilao=ALIENAÇÃO PARTICULAR&status=Aberto&status=Futuro&status=Em breve&filter_first=1`
      }  
      else if (tipo == 'Justiça Trabalhista') {
        params = `?&tipo_leilao=TRT`
      }  
      else if(tipo == 'Encerrados'){  
        params = `?status=Vendido&order_p=Vendido`;
        // params = `?status=Vendido&status=Encerrado&status=Suspenso`      
      }
      // else if(tipo == 'ALIENAÇÃO PARTICULAR'){
      //   params = `?tipo_leilao=${tipo}`
      // }
      else {
        params = `?tipo_leilao=${tipo}`
      }
      return `<a href="/leiloes/${params}">${tipo}</a>`;
    }).join('');

    tipoLeilao.innerHTML = htmlTipoLeilao;
  }
  renderizarTipoLeilao();

  const anchorTags = document.querySelectorAll(".dropdown-content a");

  // Loop through each anchor tag and capitalize the first letter of each word


  // Loop through each anchor tag and capitalize the first letter of each word
  // anchorTags.forEach((anchor) => {
  //     const words = anchor.textContent.split(' ');
     
  //     const capitalizedWords = words.map((word) => {
     

  //       if(word == 'E') {
  //         console.log('aqui ?' ,word)
  //         return word.toLocaleLowerCase()
  //       }
  //         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  //     });
  //     anchor.textContent = capitalizedWords.join(' ');
  // });
} 
